var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecordsPage',{attrs:{"member-line-id":_vm.memberLineId,"member-name":_vm.memberName,"group-id":_vm.groupId,"update-group-story-ship":_vm.updateGroupStoryShip,"update-finished-demo":_vm.updateFinishedDemo}})}
var staticRenderFns = []

export { render, staticRenderFns }